export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '2.3.0',
    name: 'fpar',
    versionDate: '2025-02-25T14:18:09.850Z',
};
export default versions;
